import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CaretDownIcon, CaretUpIcon } from '@bnb-chain/icons';
import { theme } from '@chakra-ui/react';
import { CLASS_NAMES } from '../constants';
export const SelectDropdownIndicator = () => {
    return (_jsxs(_Fragment, { children: [_jsx(CaretDownIcon, { w: theme.sizes['4'], h: theme.sizes['4'], className: CLASS_NAMES.SELECT__DROPDOWN_ICON_DOWN, display: "none" }), _jsx(CaretUpIcon, { w: theme.sizes['4'], h: theme.sizes['4'], className: CLASS_NAMES.SELECT__DROPDOWN_ICON_UP, display: "none" })] }));
};
